import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/shared/api/queryKeys';
import { svgTemplatesApi } from '@/features/deploymentSettings/api/deploymentSettings.api';

/**
 * Admin-side hooks for managing the global SVG template catalog (CRUD).
 * The overview-page consumer uses `useSvgTemplates` (read + bundled fallback);
 * here we want the raw BE list and write mutations, no fallback.
 */
export function useSvgTemplatesAdmin() {
  return useQuery({
    queryKey: queryKeys.svgTemplates.all(),
    queryFn: () => svgTemplatesApi.list(),
    staleTime: 60_000,
  });
}

function invalidate(qc) {
  return () => qc.invalidateQueries({ queryKey: queryKeys.svgTemplates.all() });
}

export function useCreateSvgTemplate() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (payload) => svgTemplatesApi.create(payload), onSuccess: invalidate(qc) });
}

export function useUpdateSvgTemplate() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: ({ id, payload }) => svgTemplatesApi.update(id, payload), onSuccess: invalidate(qc) });
}

export function useDeleteSvgTemplate() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (id) => svgTemplatesApi.remove(id), onSuccess: invalidate(qc) });
}
